import { useState } from "react";
import { Compass, ChevronRight } from "lucide-react";
import { TOURS, useTour } from "./TourProvider";

/**
 * Pick-your-path walkthrough menu (Scope A5). A floating launcher that lists the
 * available guided tours; hidden while a tour is running. In a co-driven demo EITHER
 * person can start one — the tour is shared, so it runs on both screens.
 */
export function TourLauncher() {
  const { active, start } = useTour();
  const [open, setOpen] = useState(false);
  if (active) return null;

  return (
    <div className="fixed bottom-4 left-4 z-[150] print:hidden">
      {open && (
        <div className="mb-2 w-72 overflow-hidden rounded-xl border border-[var(--color-border-gold)] bg-[var(--color-bg-deep)] shadow-[0_24px_60px_-12px_rgba(0,0,0,0.8)]">
          <p className="border-b border-[var(--color-border)] px-3 py-2 font-mono text-[9px] uppercase tracking-[0.18em] text-[var(--color-text-ghost)]">
            Guided walkthroughs
          </p>
          {TOURS.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => { start(t.id); setOpen(false); }}
              className="flex w-full items-center gap-2 px-3 py-3 text-left transition-colors hover:bg-[var(--color-navy-mid)]"
            >
              <span className="min-w-0 flex-1">
                <span className="block font-heading text-[14px] font-medium text-[var(--color-text-primary)]">{t.label}</span>
                <span className="block text-[11.5px] leading-snug text-[var(--color-text-muted)]">{t.description}</span>
              </span>
              <ChevronRight className="h-4 w-4 shrink-0 text-[var(--color-gold-soft)]" />
            </button>
          ))}
        </div>
      )}
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-2 rounded-full border border-[var(--color-border-gold)] bg-[var(--color-navy-mid)] px-4 py-2.5 font-mono text-[11px] uppercase tracking-wide text-[var(--color-gold-soft)] shadow-lg transition-colors hover:bg-[var(--color-navy-light)]"
      >
        <Compass className="h-4 w-4" /> Take a tour
      </button>
    </div>
  );
}
